import { withBasePath } from '@belong/url-utils';

/**
 * @param fileName - without leading slash
 */
export const fromStaticFolder = (fileName?: string): string => {
  const url = `/static/${fileName ?? ''}`;

  return withBasePath(url);
};
